import React from 'react';

import Banner from '@/components/Base/Banner';
import Layout from '@/components/Base/Layout';
import PageBreadcrumbs from '@/components/Base/PageBreadcrumbs';
import { ContentFooter } from '@/components/Base/PageStyles';
import HomePageContent from '@/components/Pages/Home/HomePageContent';
import HomePageFooter from '@/components/Pages/Home/HomePageFooter';
import { BreadcrumbsWrapper } from '@/components/Pages/Home/HomePageFooter/HomePageFooter.styles';
import HomePageFooterSidebar from '@/components/Pages/Home/HomePageFooterSidebar';
import HomePageHeader from '@/components/Pages/Home/HomePageHeader';
import Sidebar from '@/components/Pages/Home/Sidebar';
import { BANNERS } from '@/constants';

function HomePage() {
  return (
    <Layout dataTestId="home-page">
      <HomePageHeader />

      <HomePageContent />

      <ContentFooter>
        <HomePageFooterSidebar>
          <Sidebar />
        </HomePageFooterSidebar>

        <HomePageFooter />
      </ContentFooter>

      <BreadcrumbsWrapper>
        <Banner {...BANNERS.catfish} />

        <PageBreadcrumbs />
      </BreadcrumbsWrapper>
    </Layout>
  );
}

export default HomePage;
